import PageHeaderStyleWrapper from "./PageHeader.style";
import { IoMdHome } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, subTitle }) => {

  const navigate = useNavigate();

  const navigateTo = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  }

  return (
    <PageHeaderStyleWrapper>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-5">
            <div className="breadcrumb_area">
              <h2 className="breadcrumb_title">{subTitle}</h2>
              <div className="breadcrumb_menu">
                <p className="icon" onClick={() => navigateTo("/")}><IoMdHome /></p> <span>/</span> <p>{title}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageHeaderStyleWrapper>
  );
};

export default PageHeader;
